

@for (page of pageComponents; track page; let pageIndex = $index) {
  <div [hidden]="pageNumber != pageIndex">
    <div class="welcome">
      @for (element of page.elements; track element) {
        @if (element.type == 'header') {
          <h1>{{element.value}}</h1>
        }
        @if (element.type == 'br') {
          <br/>
        }
        @if (element.type == 'hr') {
          <hr/>
        }
        @if (element.type == 'ul') {
          <ul>
            @for (el of element.elements; track el) {
              <li>{{el.value}}</li>
            }
          </ul>
        }
        @if (element.type == 'help-references') {
          <div >
            <p>To access our original research on unconscious bias in recruitment,
              <span tabindex="0" class="popup-info" (keypress)="onShowPopup(1)" (click)="onShowPopup(1)">click here</span>.
            </p>
            <p>To view a report we commissioned into the psychology of bias, and disrupting it,
              <span tabindex="0" class="popup-info" (keypress)="onShowPopup(0)" (click)="onShowPopup(0)">click here</span>
            </p>
          </div>
        }
        @if (element.type == 'p') {
          <p [ngClass]="controller.getClassObject(element, [])">{{element.value}}</p>
        }
        @if (element.type == 'watch-now-button') {
          <button data-testid="welcome-watch-intro" (click)="onWatchIntro()" class="btn btn-outline-primary btn-outline left-button left-svg hover ">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <defs>
                <path id="a" d="M0 0h24v24H0z" />
              </defs>
              <g fill="none" fill-rule="evenodd">
                <path fill="#FFF" d="M4 19.452V4.546a2 2 0 0 1 2.986-1.74l13.15 7.453a2 2 0 0 1 0 3.48l-13.15 7.453A2 2 0 0 1 4 19.452z" />
              </g>
            </svg>
            @if (!watchedIntro) {
              <span id='watchNow'>Watch now</span>
            }
            @if (watchedIntro) {
              <span>Watch again</span>
            }
          </button>
        }
        @if (element.type == 'watch-now-button' &&watchedIntro) {
          <button id='references' (click)="showReferences()">References</button>
        }
        @if (element.type=='parts') {
          <div class="parts">
            @for (el of element.elements; track el; let index = $index) {
              <div class="part">
                <img [src]="sanitizeUrl(baseUrl + '/whats-next-images/' + el.properties.image)" alt="doodle">
                <div>
                  <div class="number">{{ index + 1 }}</div>
                  <p>{{el.value}}</p>
                </div>
              </div>
            }
          </div>
        }
        @if (element.type == 'next-button') {
          <button #customButton id='welcomeButton' (click)="onNext()" class="btn btn-outline-primary btn-outline hover active custom-next">{{element.value}}</button>
        }
      }
      @if (!haveNextButton) {
        <button id='welcomeButton' (click)="onNext()" class="btn btn-outline-primary btn-outline hover active">Next</button>
      }
      @if (page.properties && page.properties.haveContentLibraryButton) {
        <button id='gotoContentLibrary' (click)="gotoLibrary()" class="btn btn-outline-primary btn-outline next" autocus>GO TO CONTENT LIBRARY</button>
      }
    </div>
  </div>
}



<app-progress-bar [progressValue]="controller.getProgress()"></app-progress-bar>
